import isEmpty from 'lodash/isEmpty';
import { leagueTeams, teamsListFromLeague } from './links';

export const isClubBot = (club) => {
  if (!club || typeof club !== 'object') return false;
  if (club.bot === 1 || club.bot === true || club.bot === '1') return true;
  if (club.bot === 0 || club.bot === false) return false;
  if (Object.prototype.hasOwnProperty.call(club, 'user_id')) {
    return club.user_id == null;
  }
  return false;
};

const clubId = (club) => {
  if (!club) return null;
  if (club._id != null) return String(club._id);
  if (club.id != null) return String(club.id);
  return null;
};

export const collectBotTeamIds = (teams) => {
  const ids = new Set();
  (Array.isArray(teams) ? teams : []).forEach((club) => {
    const id = clubId(club);
    if (id && isClubBot(club)) ids.add(id);
  });
  return ids;
};

export const withClubBotFlag = (club, botTeamIds) => {
  if (!club || typeof club !== 'object') return club;
  const id = clubId(club);
  if (isClubBot(club) || (id && botTeamIds?.has(id))) {
    return { ...club, bot: 1 };
  }
  return club;
};

export const clubOwnerKind = ({
  team,
  academy,
  teamName,
  botTeamIds,
} = {}) => {
  if (teamName === 'Free agent') return 'freeAgent';
  const club = !isEmpty(team) ? team : academy?.team;
  if (isEmpty(club)) return 'freeAgent';
  const id = clubId(club);
  if (isClubBot(club) || (id && botTeamIds?.has(id))) return 'bot';
  return 'human';
};

const teamsFromPayload = (data) => {
  if (Array.isArray(data?.teams)) return data.teams;
  if (Array.isArray(data)) return data;
  return [];
};

export const fetchBotTeamIds = async (players) => {
  const leagueIds = new Set();
  (players || []).forEach((player) => {
    const id = player.league?._id || player.league?.id;
    if (id) leagueIds.add(id);
  });
  const urls =
    leagueIds.size > 0
      ? [...leagueIds].map((id) => `${teamsListFromLeague}${id}`)
      : [leagueTeams];
  const responses = await Promise.all(
    urls.map((url) =>
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
        credentials: 'include',
      }).catch(() => null)
    )
  );
  const ids = new Set();
  for (let i = 0; i < responses.length; i += 1) {
    const response = responses[i];
    if (!response || response.status !== 200) continue;
    try {
      const payload = await response.json();
      collectBotTeamIds(teamsFromPayload(payload)).forEach((id) => ids.add(id));
    } catch {
      // ignore a bad teams payload; player.team.bot still applies
    }
  }
  return ids;
};
